<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title>
      <v-flex xs12 v-if="messages">
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs4>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <cal-picker :label="labels.effDate" v-model="searchEffDate" @change="fetchData(ids.cover, searchEffDate)"></cal-picker>
      </v-flex>
      <v-flex xs4>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="benefit" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
      <td v-for="column in selectedColumns" :key="column">
        {{props.item[column]}}
      </td>
      <td class="text-xs-right">
        <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
      </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew">New Permission Status<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="reviewMtrCvrPermitStatus" max-width="1000px" persistent>
      <v-card>
        <v-card-title v-if="newMtrCvrPermitStatus">
          <span class="headline">New Motor Permission Status</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">Motor Permission Status</span>
        </v-card-title>
        <form data-vv-scope="mtrCvrPermStatusForm">
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap v-if="newMtrCvrPermitStatus">
                <v-flex xs4>
                  <v-autocomplete data-vv-scope="mtrCvrPermStatusForm" :items="mtrStatusFieldDescList()" v-model="mtrCvrPermStatusForm.statusField" :label="labels.statusField" item-text="label" item-value="value" data-vv-name="statusField" :data-vv-as="labels.statusField" :error-messages="errors.collect('mtrCvrPermStatusForm.statusField')" v-validate="'required'" @change="doOperatorList"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="isDrv">
                  <v-autocomplete data-vv-scope="mtrCvrPermStatusForm" :hint="!mtrCvrPermStatusForm.statusField? 'Please Choose Status Field First':''" :persistent-hint="!mtrCvrPermStatusForm.statusField" :no-data-text="labels.noDatatext" :items="operatorList" v-model="mtrCvrPermStatusForm.statusVal" :label="labels.statusVal" item-text="label" item-value="value" data-vv-name="statusVal" :data-vv-as="labels.statusVal" :error-messages="errors.collect('mtrCvrPermStatusForm.statusVal')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="isDrv">
                </v-flex>
                <v-flex xs4 v-if="!isDrv">
                  <v-autocomplete data-vv-scope="mtrCvrPermStatusForm" :hint="!mtrCvrPermStatusForm.statusField? 'Please Choose Status Field First':''" :persistent-hint="!mtrCvrPermStatusForm.statusField" :no-data-text="labels.noDatatext" :items="operatorList" v-model="mtrCvrPermStatusForm.operator" :label="labels.operator" item-text="label" item-value="value" data-vv-name="operator" :data-vv-as="labels.operator" :error-messages="errors.collect('mtrCvrPermStatusForm.operator')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!isDrv">
                  <v-text-field data-vv-scope="mtrCvrPermStatusForm" v-model="mtrCvrPermStatusForm.statusVal" :label="labels.statusVal" :error-messages="errors.collect('mtrCvrPermStatusForm.statusVal')" data-vv-name="statusVal" :data-vv-as="labels.statusVal" v-validate="'required|entry|max:50'"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <cal-picker data-vv-scope = "mtrCvrPermStatusForm" :label="labels.effDate" v-model="mtrCvrPermStatusForm.effDate" :error-messages="errors.collect('mtrCvrPermStatusForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <cal-picker data-vv-scope = "mtrCvrPermStatusForm" :label="labels.endDate" v-model="mtrCvrPermStatusForm.endDate" :error-messages="errors.collect('mtrCvrPermStatusForm.endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete data-vv-scope = "mtrCvrPermStatusForm" :items="permitStatusList()" v-model="mtrCvrPermStatusForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('mtrCvrPermStatusForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{labels.statusField}}</v-subheader>
                  <div class="title">{{mtrCvrPermStatusForm.statusFieldDesc}}</div>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{labels.operator}}</v-subheader>
                  <div class="title">{{mtrCvrPermStatusForm.operatorDesc}}</div>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{labels.statusVal}}</v-subheader>
                  <div class="title">{{mtrCvrPermStatusForm.statusVal}}</div>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
                  <div class="title">{{formatDate(mtrCvrPermStatusForm.effDate)}}</div>
                </v-flex>
                <v-flex xs4>
                  <cal-picker data-vv-scope = "mtrCvrPermStatusForm" :label="labels.endDate" v-model="mtrCvrPermStatusForm.endDate" :error-messages="errors.collect('mtrCvrPermStatusForm.endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate" :min="mtrCvrPermStatusForm.effDate"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <v-autocomplete data-vv-scope = "mtrCvrPermStatusForm" :items="permitStatusList()" v-model="mtrCvrPermStatusForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('mtrCvrPermStatusForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSave">
            {{newMtrCvrPermitStatus ? 'Save Permission Status' : 'Update Permission Status'}}
            <v-icon right>{{newMtrCvrPermitStatus ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
          </v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Coverage Permission?
      <div class="title">{{deletePerm}}</div>
    </confirm>
  </v-card>
</template>

<script>
import { listMixin } from '../../listMixin.js'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { mtrStatusFieldDesc, mtrPermitStatus, mtrStatusField } from '@/const/underwriting/motor'
export default {
  data() {
    return {
      columns: [
        { text: 'Status Field', value: 'statusFieldDesc' },
        { text: 'Operator', value: 'operatorDesc' },
        { text: 'Status Value', value: 'statusVal' },
        { text: 'Permission Status', value: 'permitStatusDesc' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'End Date', value: 'endDate' }
      ],
      selectedColumns: ['statusFieldDesc', 'operatorDesc', 'statusVal', 'permitStatusDesc', 'effDate'],
      mtrCvrPermStatusForm: {
        statusField: null,
        statusFieldDesc: null,
        operator: null,
        statusVal: null,
        permitStatus: null,
        effDate: null,
        endDate: null
      },
      labels: {
        statusField: 'Status Field*',
        operator: 'Operator*',
        statusVal: 'Status Value*',
        permitStatus: 'Permission Status*',
        effDate: 'Effective Date*',
        endDate: 'End Date',
        noDatatext: 'Please Choose Status Field First'
      },
      searchEffDate: null,
      loading: false,
      operatorList: [],
      isDrv: false,
      newMtrCvrPermitStatus: false,
      reviewMtrCvrPermitStatus: false,
      submitting: false,
      deletePerm: '',
      promptRemove: false
    }
  },
  watch: {
    'ids.cover': function(value) {
      this.fetchData(value, this.searchEffDate)
    },
    'searchEffDate': function(value) {
      this.fetchData(this.ids.cover, value)
    }
  },
  computed: {
    busClsCoverMenu() {
      return this.$store.state.parameters.busCls.cover.menu
    }
  },
  methods: {
    async fetchData(cover, effDate) {
      this.loading = true
      const apiURI = this.busClsCoverMenu.mtrCvrPermStatuses
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            cover: cover,
            effDate: effDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((cvrPermStatus) => {
              const convertList = {
                effDate: this.formatDate(cvrPermStatus.effDate),
                endDate: this.formatDate(cvrPermStatus.endDate),
                operatorDesc: cvrPermStatus.operatorDesc,
                operator: cvrPermStatus.operator,
                permitStatus: cvrPermStatus.permitStatus,
                permitStatusDesc: cvrPermStatus.permitStatus + ' - ' + mtrPermitStatus[cvrPermStatus.permitStatus],
                statusField: cvrPermStatus.statusField,
                statusFieldDesc: cvrPermStatus.statusField + ' - ' + mtrStatusFieldDesc[cvrPermStatus.statusField],
                statusVal: cvrPermStatus.statusVal
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doReview(item) {
      const apiURI = this.busClsCoverMenu.mtrCvrPermStatusGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            cover: this.ids.cover,
            statusField: item.item.statusField,
            operator: item.item.operator,
            statusVal: item.item.statusVal,
            effDate: item.item.effDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Init Form
            this.mtrCvrPermStatusForm.statusField = data.mtrCvrPermStatus.statusField
            this.mtrCvrPermStatusForm.statusFieldDesc = item.item.statusFieldDesc
            this.mtrCvrPermStatusForm.operator = data.mtrCvrPermStatus.operator
            this.mtrCvrPermStatusForm.operatorDesc = item.item.operatorDesc
            this.mtrCvrPermStatusForm.statusVal = data.mtrCvrPermStatus.statusVal
            this.mtrCvrPermStatusForm.permitStatus = data.mtrCvrPermStatus.permitStatus
            this.mtrCvrPermStatusForm.effDate = data.mtrCvrPermStatus.effDate
            this.mtrCvrPermStatusForm.endDate = data.mtrCvrPermStatus.endDate
            // control
            this.reviewMtrCvrPermitStatus = true
            this.newMtrCvrPermitStatus = false
          }
        } catch (error) {
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClear() {
      this.mtrCvrPermStatusForm.statusField = null
      this.mtrCvrPermStatusForm.statusFieldDesc = null
      this.mtrCvrPermStatusForm.operator = null
      this.mtrCvrPermStatusForm.operatorDesc = null
      this.mtrCvrPermStatusForm.statusVal = null
      this.mtrCvrPermStatusForm.permitStatus = null
      this.mtrCvrPermStatusForm.effDate = null
      this.mtrCvrPermStatusForm.endDate = null
      this.operatorList = []
      this.resetValidator()
      this.resetMessages()
    },
    doNew() {
      this.doClear()
      this.newMtrCvrPermitStatus = true
      this.reviewMtrCvrPermitStatus = true
    },
    doClose() {
      this.doClear()
      this.newMtrCvrPermitStatus = false
      this.reviewMtrCvrPermitStatus = false
      this.isDrv = false
    },
    doSave() {
      this.resetMessages()
      this.resetValidator()
      this.$validator.validateAll('mtrCvrPermStatusForm').then(result => {
        if (result) {
          if (this.newMtrCvrPermitStatus) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.busClsCoverMenu.mtrCvrPermStatusCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.ids.busCls,
            cvrType: this.ids.cover,
            statusField: this.mtrCvrPermStatusForm.statusField,
            operator: this.mtrCvrPermStatusForm.operator,
            statusVal: this.mtrCvrPermStatusForm.statusVal,
            permitStatus: this.mtrCvrPermStatusForm.permitStatus,
            effDate: this.mtrCvrPermStatusForm.effDate,
            endDate: this.mtrCvrPermStatusForm.endDate
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(this.ids.cover, this.searchEffDate)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      try {
        const apiURI = this.busClsCoverMenu.mtrCvrPermStatusUpdate
        if (apiURI) {
          const formatForm = {
            busCls: this.ids.busCls,
            cvrType: this.ids.cover,
            statusField: this.mtrCvrPermStatusForm.statusField,
            operator: this.mtrCvrPermStatusForm.operator,
            statusVal: this.mtrCvrPermStatusForm.statusVal,
            permitStatus: this.mtrCvrPermStatusForm.permitStatus,
            effDate: this.mtrCvrPermStatusForm.effDate,
            endDate: this.mtrCvrPermStatusForm.endDate
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(this.ids.cover, this.searchEffDate)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    permitStatusList() {
      const list = Object.freeze(mtrPermitStatus)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    mtrStatusFieldDescList() {
      const list = Object.freeze(mtrStatusFieldDesc)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    doOperatorList(statusField) {
      this.operatorList = []
      if (statusField === mtrStatusField.ISDRV) {
        const list = [
          { label: 'Yes - true', value: 'true' },
          { label: 'No - false', value: 'false' }
        ]
        this.isDrv = true
        this.mtrCvrPermStatusForm.operator = '=='
        Object.assign(this.operatorList, list)
      } else {
        const list = [
          { label: 'Equal', value: '==' },
          { label: 'Greater Than', value: '>' },
          { label: 'Greater Than Equal', value: '>=' },
          { label: 'Less Than', value: '<' },
          { label: 'Less Than Equal', value: '<=' }
        ]
        this.isDrv = false
        this.mtrCvrPermStatusForm.operator = null
        this.mtrCvrPermStatusForm.statusVal = null
        Object.assign(this.operatorList, list)
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPerm = data
        this.deletePerm = data.statusField + ' ' + data.operator + ' ' + data.statusVal
      }
    },
    async doRemove() {
      const apiURI = this.busClsCoverMenu.mtrCvrPermStatusDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.ids.busCls,
          cvrType: this.ids.cover,
          statusField: this.selectedPerm.statusField,
          operator: this.selectedPerm.operator,
          statusVal: this.selectedPerm.statusVal,
          permitStatus: this.selectedPerm.permitStatus,
          effDate: this.removeFormatDate(this.selectedPerm.effDate),
          endDate: this.removeFormatDate(this.selectedPerm.endDate)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.cover, this.searchEffDate)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Coverage Permission')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  mounted() {
    this.fetchData(this.ids.cover, this.searchEffDate)
  },
  props: {
    ids: Object
  },
  mixins: [
    listMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
